export var PipelineName;
(function (PipelineName) {
    PipelineName["Build"] = "Build";
    PipelineName["Release"] = "Release";
})(PipelineName || (PipelineName = {}));
